import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from '@thd-olt-component-react/router';
import { useConfigService } from '@thd-nucleus/experience-context';
import Configurator from '../app/components/configurator/index';
import { usePlaConfigurationsParams } from './hooks';

import '../app/index.global.scss';

export const PcpApp = ({ history, config }) => {
  const countertopsBaseUrl = useConfigService('countertops-base-url');
  let location = useLocation();
  let match = useParams();
  const { configurationIdForSelections } = usePlaConfigurationsParams();

  const configServiceProps = {
    paymentEstimatorVersion: useConfigService('PaymentEstimatorVersion') || 'v1.0.16'
  };
  return (
    <div className="container">
      <Configurator
        history={history}
        location={location}
        match={match}
        configServiceProps={configServiceProps}
        configurationIdForSelections={configurationIdForSelections}
        config={config}
        countertopsBaseUrl={countertopsBaseUrl}
      />
    </div>
  );
};

PcpApp.propTypes = {
  config: PropTypes.shape({}),
  history: PropTypes.shape({}),
};

PcpApp.defaultProps = {
  config: {},
  history: {},
};

PcpApp.displayName = 'PcpPage';
